import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { EmailEditorComponent } from 'angular-email-editor';
import { HelpersService } from '../../../../../services/helpers.service';
import { PartnerService } from '../../../../../services/partner.service';
import { RentalsService } from '../../../../../services/rentals.service';
import { AppConfig } from '../../../../../app.config';
import { ConfirmationService } from 'primeng/api';
import whatsAppButtonList from './whatsapp_call_to_action_buttons.json';

@Component({
  selector: 'app-message-type-panel',
  templateUrl: './message-type-panel.component.html',
  styleUrls: ['./message-type-panel.component.scss'],
})
export class MessageTypePanelComponent implements OnInit {
  @Input() selectedMessageTemplate;
  @Input() messageTemplates;
  @Input() whatsappConfiguredEnabled;
  @Output() closePanel = new EventEmitter();

  public partnerId = 0;
  public messageTemplate: any = {};
  public originalMessageTemplate: any = {};
  public saving: boolean = false;
  public loading: boolean = false;
  public classicTemplate = false;
  public screenHeight: number = 0;
  public partner: any = {};
  public templateImport: any = null;
  public filteredMessageTemplates: any = [];
  public uploadingWhatsAppHeaderImage: boolean = false;
  public eventWhatsappCallToActionButtons: any = [];
  public hideNonWhatsapp : boolean = false;

  public appearance: any = {
    theme: 'light',
    panels: {
      tools: {
        dock: 'left',
      },
    },
  };
  public options: any = {
    id: 'editor-container',
    displayMode: 'email',
    safeHtml: true,
    //{},
    mergeTags: {
      partner_name: {
        name: 'Shop Name',
        value: '$Partner.Name$',
      },
      phone_number: {
        name: 'Shop Phone Number',
        value: '$Partner.PhoneNumber1$',
      },
      partner_freetext: {
        name: 'Shop Free Text',
        value: '$Partner.FreeText$',
      },
      customer_name: {
        name: 'Customer Name',
        value: '$Customer.Name$',
      },
      workshop_address: {
        name: 'Workshop Address',
        value: '$Workshop.Address$',
      }     
    },
    designTags: {
      partner_logo: this.helpersService.getPartnerData().ImageURL,
    },
    designTagsConfig: {
      delimiter: ['[[', ']]'],
    },
  };

  public whatsappButtonProperties: any = [
    { Type: 'VIEW_JOBCARD', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.view_job_card') },
    { Type: 'VIEW_QUOTE', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.view_quote') },
    { Type: 'VIEW_QUOTE_OPTIONS', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.view_quote_options') },
    { Type: 'RESCHEDULE_SERVICE', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.reschedule_service') },
    { Type: 'RESCHEDULE_FITTING', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.reschedule_fitting') },

    { Type: 'VIEW_RESERVATION', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.view_reservation') },
    { Type: 'UPDATE_RENTAL_PAYMENT_DETAILS', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.update_payment_details') },
    { Type: 'RATE_RENTAL_SERVICE', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.rate_rental_service') },
    { Type: 'SIGN_RENTAL_WAIVER', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.sign_waiver') },
    { Type: 'SCHEDULE_SERVICE_DELIVERY', ButtonLabel: this.translate.instant('bikeshop.message_templates.whatsapp.controls.button_options.schedule_delivery') },

  ];


  public whatsappHeaderTypeOptions: any = [
    { value: 'NONE', label: this.translate.instant('bikeshop.message_templates.whatsapp.controls.whatsapp_header_options.none') },
    { value: 'TEXT', label: this.translate.instant('bikeshop.message_templates.whatsapp.controls.whatsapp_header_options.text') },
    { value: 'IMAGE', label: this.translate.instant('bikeshop.message_templates.whatsapp.controls.whatsapp_header_options.image') },
    { value: 'LOCATION', label: this.translate.instant('bikeshop.message_templates.whatsapp.controls.whatsapp_header_options.location') }
  ]

  constructor(
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    public messageService: MessageService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private rentalsService: RentalsService,
    public appConfig: AppConfig,
  ) {
    this.partnerId = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();
  }

  @ViewChild(EmailEditorComponent) private emailEditor: EmailEditorComponent;

  ngOnInit() {
    this.messageTemplate = this.selectedMessageTemplate;
    if (this.selectedMessageTemplate.Description.indexOf('Bike Sale') > -1) {
      this.options.projectId = 39959;
    }

    if(this.selectedMessageTemplate && this.selectedMessageTemplate.EventTag.indexOf("whatsapp.") > -1){
      this.hideNonWhatsapp = true;

      if(this.messageTemplate.EventTag == "whatsapp.workshop.chat.initiate" && (this.messageTemplate.WhatsappBodyText === null || this.selectedMessageTemplate === "")){
        this.messageTemplate.WhatsappBodyText = this.translate.instant("whatsapp.workshop.chat.initiate.default");
      }
      if(this.messageTemplate.EventTag == "whatsapp.rentals.chat.initiate" && (this.messageTemplate.WhatsappBodyText === null || this.selectedMessageTemplate === "")){
        this.messageTemplate.WhatsappBodyText = this.translate.instant("whatsapp.rentals.chat.initiate.default");
      }
    }

    //this.filteredMessageTemplates = this.messageTemplates.filter(x=>{return x.TemplateDesign !== null && x.TemplateDesign.length > 0 && x.ID !== this.selectedMessageTemplate}).map(x=>{return {label: this.translate.instant(x.EventTag+'_title', {ServiceFollowUpReminderMonths : this.partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService : this.partner.ReminderHoursBeforeService, WaitingDelayHours : this.partner.WaitingDelayHours}) ,value: x.TemplateDesign}});
    this.filteredMessageTemplates = this.messageTemplates
      .filter((x) => {
        return x.TemplateDesign && x.TemplateDesign.length > 0 && x.IsActive;
      })
      .sort((x, y) => {
        if (
          this.translate.instant(x.EventTag + '_title') <
          this.translate.instant(y.EventTag + '_title')
        ) {
          return -1;
        } else if (
          this.translate.instant(x.EventTag + '_title') >
          this.translate.instant(y.EventTag + '_title')
        ) {
          return 1;
        } else {
          return 0;
        }
      })
      .map((x) => {
        return {
          label: this.translate.instant(x.EventTag + '_title', {
            ServiceFollowUpReminderMonths:
              this.partner.ServiceFollowUpReminderMonths,
            ReminderHoursBeforeService: this.partner.ReminderHoursBeforeService,
            WaitingDelayHours: this.partner.WaitingDelayHours,
            OtherServiceFollowUpReminderMonths:
              this.partner.OtherServiceFollowUpReminderMonths,
            PostServiceFollowUpDays: this.partner.PostServiceFollowUpDays,
          }),
          value: { TemplateDesign: x.TemplateDesign, Template: x.Template },
        };
      });
    this.getMessageTemplate();
    this.screenHeight = window.innerHeight;
  }

  listMergeTags() {
    var list = [];
    for (var tag in this.options.mergeTags) {
      list.push(this.options.mergeTags[tag]);
    }
    return list;
  }

  loadWhatsappButtons() {
    var wasWhatsappActive = this.originalMessageTemplate.WhatsappActive;

    this.eventWhatsappCallToActionButtons = this.messageTemplate.WhatsappCallToActionButtons.map(x => { return { ...x, selected: true } });


    var whatAppEventButtons = whatsAppButtonList.filter(x => x.EventTag == this.messageTemplate.EventTag).pop();
    if (whatAppEventButtons && whatAppEventButtons.ButtonOptions) {
      whatAppEventButtons.ButtonOptions.forEach(button => {
        var buttonObject = this.whatsappButtonProperties.filter(x => x.Type === button).pop();
        if (buttonObject && this.eventWhatsappCallToActionButtons.filter(x => { return x.Type === buttonObject.Type }).length === 0) {
          if(wasWhatsappActive){
            this.eventWhatsappCallToActionButtons.push(buttonObject);
          } else{
            this.eventWhatsappCallToActionButtons.push({...buttonObject, selected: true});
          }         
        }
      });
    }
  }

  getMessageTemplate() {
    this.loading = true;
    //this.messageTemplate = {};
    if (this.selectedMessageTemplate.ID > 0) {
      this.partnerService
        .getMessageTemplateV2(
          this.partnerId.toString(),
          this.selectedMessageTemplate.ID,
        )
        .subscribe((template) => {
          this.messageTemplate = template;
          this.originalMessageTemplate = JSON.parse(JSON.stringify(template));

          this.loadWhatsappButtons();

          if (this.messageTemplate.EventTag.indexOf('shopride.') === 0)
          {
            this.options.mergeTags['ride_title'] = {
              name: 'Ride Title',
              value: '$Ride.Title$',
            };
            this.options.mergeTags['ride_date'] = {
              name: 'Ride Date',
              value: '$Ride.Date$',
            };
            this.options.mergeTags['ride_time'] = {
              name: 'Ride Time',
              value: '$Ride.Time$',
            };
            this.options.mergeTags['ride_location'] = {
              name: 'Ride Location',
              value: '$Ride.Location$',
            };
            this.options.mergeTags['ride_googlemapurl'] = {
              name: 'Ride GoogleMapUrl',
              value: '$Ride.GoogleMapUrl$',
            };
            this.options.mergeTags['ride_viewurl'] = {
              name: 'Ride ViewUrl',
              value: '$Ride.ViewUrl$',
            };
          }

          if (
            this.messageTemplate.EventTag.indexOf('service.') === 0 ||
            this.messageTemplate.EventTag.indexOf('fitting.') === 0
          ) {
            this.options.mergeTags['item_manufacturer'] = {
              name: 'Item Manufacturer',
              value: '$Item.Manufacturer$',
            };
            this.options.mergeTags['scheduled_date'] = {
              name: 'Booking Date',
              value: '$Service.ScheduledDate$',
            };
            this.options.mergeTags['scheduled_date_time'] = {
              name: 'Booking Date with Time',
              value: '$Service.ScheduledDateTime$',
            };
            this.options.mergeTags['sheduled_time'] = {
              name: 'Booking Time',
              value: '$Time$',
            };
            this.options.mergeTags['referral_code'] = {
              name: 'Referral Code',
              value: '$ReferralCode$',
            };
            this.options.mergeTags['referral_balance'] = {
              name: 'Refferal Balance',
              value: '$ReferralBalance$',
            };
            this.options.mergeTags['checklists'] = {
              name: 'Checklist',
              value: '$ChecklistItems$',
            };
          }

          if (
            this.messageTemplate.EventTag === 'service.complete' ||
            this.messageTemplate.EventTag === 'service.start' ||
            this.messageTemplate.EventTag === 'service.waitingforclient' ||
            this.messageTemplate.EventTag === 'service.waitingforparts' ||
            this.messageTemplate.EventTag === 'service.warranty'
          ) {
            this.options.mergeTags['job_card_link'] = {
              name: 'Job Card Link',
              value: '$url$',
            };
          }

          if (this.messageTemplate.EventTag === 'service.pickup') {
            this.options.mergeTags['collection_date'] = {
              name: 'Collection Date',
              value: '$Collection.Date$',
            };
            this.options.mergeTags['collection_time'] = {
              name: 'Collection Time',
              value: '$Collection.Time$',
            };
          }

          if (
            this.messageTemplate.EventTag === 'service.pickup' ||
            this.messageTemplate.EventTag === 'service.bookin'
          ) {
            this.options.mergeTags['reschedule_link'] = {
              name: 'Reschedule Link',
              value: '$RescheduleLink$',
            };
            this.options.mergeTags['waiver_url'] = {
              name: 'Waiver URL',
              value: '$WaiverURL$',
            };
          }

          if (
            this.messageTemplate.EventTag === 'service.approval' ||
            this.messageTemplate.EventTag === 'service.multiapproval'
          ) {
            this.options.mergeTags['approval_link'] = {
              name: 'Approval Link',
              value: '$url$',
            };
          }

          if (
            this.messageTemplate.EventTag.indexOf('rentals.') === 0 
          )
          {
            this.options.mergeTags['reservation_date'] = {
              name: 'Rental Reservation Date',
              value: '$Rentals.ReservationDate$',
            };
            this.options.mergeTags['reservation_time'] = {
              name: 'Rental Reservation Time',
              value: '$Rentals.ReservationTime$',
            };
            this.options.mergeTags['reservation_date_time'] = {
              name: 'Rental Reservation Date Time',
              value: '$Rentals.ReservationDateTime$',
            };
            this.options.mergeTags['reservation_duration'] = {
              name: 'Rental Reservation Duration',
              value: '$Rentals.ReservationDuration$',
            };
            this.options.mergeTags['reservation_duration'] = {
              name: 'Rental Invoice',
              value: '$Rentals.Invoice$',
            };
            this.options.mergeTags['reservation_reserved_products'] = {
              name: 'Rental Reserved Products',
              value: '$Rentals.ReservedProducts$',
            };            
          }

          if (
            this.messageTemplate.EventTag === 'rentals.delivery' ||
            this.messageTemplate.EventTag === 'rentals.booked' ||
            this.messageTemplate.EventTag === 'rentals.reservation_reminder' ||
            this.messageTemplate.EventTag === 'rentals.return_overdue' ||
            this.messageTemplate.EventTag === 'rentals.sendwaiver' ||
            this.messageTemplate.EventTag === 'rentals.waiversigned'
          ) {
            this.options.mergeTags['reservation_date'] = {
              name: 'Rental Reservation Date',
              value: '$Rentals.ReservationDate$',
            };
            this.options.mergeTags['reservation_time'] = {
              name: 'Rental Reservation Time',
              value: '$Rentals.ReservationTime$',
            };
            this.options.mergeTags['reservation_return_date'] = {
              name: 'Rental Reservation Return Date',
              value: '$Rentals.ReservationReturnDate$',
            };
            this.options.mergeTags['reservation_return_time'] = {
              name: 'Rental Reservation Return Time',
              value: '$Rentals.ReservationReturnTime$',
            };
            this.options.mergeTags['reservation_return_date_time'] = {
              name: 'Rental Reservation Return Date Time',
              value: '$Rentals.ReservationReturnDateTime$',
            };
            this.options.mergeTags['waiver_url'] = {
              name: 'Waiver URL',
              value: '$Rentals.WaiverURL$',
            };
          }
          if (
            this.messageTemplate.EventTag === 'rentals.delivery'
          ) {
            this.options.mergeTags['rental_delivery_date'] = {
              name: 'Rental Delivery Date',
              value: '$Rentals.DeliveryDate$',
            };
            this.options.mergeTags['rental_delivery_slot'] = {
              name: 'Rental Delivery Slot',
              value: '$Rentals.DeliverySlot$',
            };
          }
          if (this.messageTemplate.EventTag === 'rentals.waiversigned') {
            this.options.mergeTags['waiver'] = {
              name: 'Waiver & Signature',
              value: '$waiver$',
            };
          }
          if (this.messageTemplate.EventTag === 'rentals.returned') {
            this.options.mergeTags['rental_returned'] = {
              name: 'Rating URL',
              value: '$Rentals.URL$',
            };
          }
          if (this.messageTemplate.EventTag === 'service.deliverybooked') {
            this.options.mergeTags['delivery_booked'] = {
              name: 'Delivery Booked URL',
              value: '$Delivery.URL$',
            };
          }
          if (
            this.messageTemplate.EventTag === 'service.waiversigned' ||
            this.messageTemplate.EventTag === 'fitting.waiversigned'
          ) {
            this.options.mergeTags['waiver'] = {
              name: 'Waiver & Signature',
              value: '$waiver$',
            };
            this.options.mergeTags['waiver_url'] = {
              name: 'Waiver URL',
              value: '$WaiverURL$',
            };
          }

          if (this.messageTemplate.WARejectReason) {
            try {
              this.messageTemplate.WARejectReason = JSON.parse(this.messageTemplate.WARejectReason)
            } catch (e) { }
          }
          setTimeout(() => {
            this.editorLoaded();
          }, 1000);

          this.loading = false;
        });
    }
  }

  saveTemplate() {
    this.saving = true;
    if (this.emailEditor) {
      this.emailEditor.saveDesign((design) => {
        this.messageTemplate.TemplateDesign = JSON.stringify(design);
        this.emailEditor.exportHtml((html) => {
          this.messageTemplate.Template = html['html'];
          this.save();
        });
      });
    } else {
      this.save();
    }
  }

  hasWhatsappChanged() {
    var whatsappOrig = {
      WhatsappBodyText: this.originalMessageTemplate.WhatsappBodyText,
      WhatsappCallToActionButtons: this.messageTemplate.WhatsappCallToActionButtons.map(x => { return { ...x, selected: true } }),
      WhatsappFooterText: this.originalMessageTemplate.WhatsappFooterText,
      WhatsappHeaderImage: this.originalMessageTemplate.WhatsappHeaderImage,
      WhatsappHeaderText: this.originalMessageTemplate.WhatsappHeaderText,
      WhatsappHeaderType: this.originalMessageTemplate.WhatsappHeaderType
    }
    var whatsappNow = {
      WhatsappBodyText: this.messageTemplate.WhatsappBodyText,
      WhatsappCallToActionButtons: this.eventWhatsappCallToActionButtons.filter(x => x.selected),
      WhatsappFooterText: this.messageTemplate.WhatsappFooterText,
      WhatsappHeaderImage: this.messageTemplate.WhatsappHeaderImage,
      WhatsappHeaderText: this.messageTemplate.WhatsappHeaderText,
      WhatsappHeaderType: this.messageTemplate.WhatsappHeaderType
    }

    return !this.deepEqual(whatsappOrig, whatsappNow);
  }

  save() {
    this.messageTemplate.WARejectReason = null;

    var data = { ...this.messageTemplate, WhatsappCallToActionButtons: this.eventWhatsappCallToActionButtons.filter(x => x.selected), hasWhatsappChanged: this.hasWhatsappChanged() }
    
    this.partnerService.saveMessageTemplateV2(data).subscribe(
      (template) => {
        this.messageTemplate = template;
        this.saving = false;
        this.closePanel.emit();
        this.messageService.add({
          life: 5000,
          summary: this.translate.instant(
            'bikeshop.message_templates.template_updated',
          ),
          detail: this.translate.instant(
            'bikeshop.message_templates.message_updated',
            { EventTag: this.messageTemplate.EventTag },
          ),
        });
      },
      (err) => {
        this.saving = false;
      },
    );
  }

  editorLoaded() {
    if (this.emailEditor && this.emailEditor.editor) {
      if (
        this.messageTemplate.TemplateDesign &&
        JSON.parse(this.messageTemplate.TemplateDesign).counters
      ) {
        this.emailEditor.editor.loadDesign(
          JSON.parse(this.messageTemplate.TemplateDesign),
        );
        this.classicTemplate = false;
      } else if (
        this.messageTemplate.Template &&
        this.messageTemplate.Template.length > 0
      ) {
        this.emailEditor.editor.loadDesign({
          html: this.messageTemplate.Template,
          classic: true,
        });
        this.classicTemplate = true;
      } else {
        this.emailEditor.editor.loadDesign({
          counters: { u_column: 1, u_row: 1, u_content_html: 1 },
          body: {
            rows: [
              {
                cells: [1],
                columns: [
                  {
                    contents: [],
                    values: {
                      backgroundColor: '',
                      padding: '0px',
                      border: {},
                      _meta: {
                        htmlID: 'u_column_1',
                        htmlClassNames: 'u_column',
                      },
                    },
                  },
                ],
                values: {
                  displayCondition: null,
                  columns: false,
                  backgroundColor: '',
                  columnsBackgroundColor: '',
                  backgroundImage: {
                    url: '',
                    fullWidth: true,
                    repeat: false,
                    center: true,
                    cover: false,
                  },
                  padding: '0px',
                  hideDesktop: false,
                  hideMobile: false,
                  noStackMobile: false,
                  _meta: { htmlID: 'u_row_1', htmlClassNames: 'u_row' },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                },
              },
            ],
            values: {
              backgroundColor: '#ffffff',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: false,
                center: true,
                cover: false,
              },
              contentWidth: '500px',
              contentAlign: 'center',
              fontFamily: {
                label: 'Arial',
                value: 'arial,helvetica,sans-serif',
              },
              preheaderText: '',
              linkStyle: {
                body: true,
                linkColor: '#0000ee',
                linkHoverColor: '#0000ee',
                linkUnderline: true,
                linkHoverUnderline: true,
              },
              _meta: { htmlID: 'u_body', htmlClassNames: 'u_body' },
            },
          },
          schemaVersion: 5,
        });
        this.classicTemplate = false;
      }

      this.emailEditor.editor.registerCallback('image', (file, done) => {
        let uploadFile = file.attachments[0];

        var reader = new FileReader();
        reader.readAsDataURL(uploadFile);
        reader.onload = (file: any) => {
          let data = {
            Image: file.target.result,
            Folder: 'partnerphotos',
            Type: 'MessageTemplateImage',
          };

          this.partnerService
            .uploadImage(data, this.partnerId)
            .subscribe((result) => {
              console.log(result);
              done({ url: result });
            });
        };
      });
    }
  }

  resetTemplate() {
    this.confirmationService.confirm({
      key: 'add_edit_message_templates',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant(
        'bikeshop.message_templates.convert_template_header',
      ),
      message: this.translate.instant(
        'bikeshop.message_templates.convert_template',
      ),
      accept: () => {
        this.emailEditor.editor.loadDesign({
          counters: { u_column: 1, u_row: 1, u_content_html: 1 },
          body: {
            rows: [
              {
                cells: [1],
                columns: [
                  {
                    contents: [],
                    values: {
                      backgroundColor: '',
                      padding: '0px',
                      border: {},
                      _meta: {
                        htmlID: 'u_column_1',
                        htmlClassNames: 'u_column',
                      },
                    },
                  },
                ],
                values: {
                  displayCondition: null,
                  columns: false,
                  backgroundColor: '',
                  columnsBackgroundColor: '',
                  backgroundImage: {
                    url: '',
                    fullWidth: true,
                    repeat: false,
                    center: true,
                    cover: false,
                  },
                  padding: '0px',
                  hideDesktop: false,
                  hideMobile: false,
                  noStackMobile: false,
                  _meta: { htmlID: 'u_row_1', htmlClassNames: 'u_row' },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                },
              },
            ],
            values: {
              backgroundColor: '#ffffff',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: false,
                center: true,
                cover: false,
              },
              contentWidth: '500px',
              contentAlign: 'center',
              fontFamily: {
                label: 'Arial',
                value: 'arial,helvetica,sans-serif',
              },
              preheaderText: '',
              linkStyle: {
                body: true,
                linkColor: '#0000ee',
                linkHoverColor: '#0000ee',
                linkUnderline: true,
                linkHoverUnderline: true,
              },
              _meta: { htmlID: 'u_body', htmlClassNames: 'u_body' },
            },
          },
          schemaVersion: 5,
        });
        this.classicTemplate = false;
      },
    });
  }

  cancel() {
    this.closePanel.emit();
  }

  templateChanged() {
    return !this.deepEqual(this.messageTemplate, this.originalMessageTemplate);
  }

  deepEqual = (x, y) => {
    return x && y && typeof x === 'object' && typeof y === 'object'
      ? Object.keys(x).length === Object.keys(y).length &&
      Object.keys(x).reduce((isEqual, key) => {
        return isEqual && this.deepEqual(x[key], y[key]);
      }, true)
      : x === y;
  };

  importDesign() {
    this.messageTemplate.Template = '';
    this.messageTemplate.TemplateDesign = null;
    this.editorLoaded();
    this.messageTemplate.Template = JSON.parse(
      JSON.stringify(this.templateImport.Template),
    );
    this.messageTemplate.TemplateDesign =
      this.templateImport.TemplateDesign === '{}'
        ? null
        : JSON.parse(JSON.stringify(this.templateImport.TemplateDesign));
    this.originalMessageTemplate = JSON.parse(
      JSON.stringify(this.templateImport.Template),
    );
    this.editorLoaded();
    this.templateImport = null;
  }

  uploadWhatsAppHeaderImage(event) {
    this.uploadingWhatsAppHeaderImage = true;
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.messageTemplate.WhatsappHeaderImage = reader.result.toString();

      var mediaData = {
        PartnerID: this.helpersService.getPartnerId(),
        MediaData: reader.result.toString().replace(/^data:(.*;base64,)?/, ''),
      };
      this.rentalsService.uploadRentalImage(mediaData).subscribe(
        (res) => {
          this.messageTemplate.WhatsappHeaderImage = res.imageURL;
          this.uploadingWhatsAppHeaderImage = false;
        },
        (err) => {
          this.messageTemplate.WhatsappHeaderImage = null;
          this.uploadingWhatsAppHeaderImage = false;
        },
      );
      setTimeout(() => {
        this.uploadingWhatsAppHeaderImage = false;
      }, 2000)
    };
  }

  getObjectString(object) {
    return JSON.stringify(object);
  }
}
